import { render, staticRenderFns } from "./DataListFamilyComponent.vue?vue&type=template&id=f4637f18&"
import script from "./DataListFamilyComponent.vue?vue&type=script&lang=js&"
export * from "./DataListFamilyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports